/* =============================================
   Amanah LLC — Commande en ligne
   Fenêtre « Commander ma LLC » : choix du moyen de contact,
   ajout du produit au panier (quantité 1) avec les coordonnées
   en propriétés de ligne, puis redirection vers le checkout Shopify.
   Aucun événement publicitaire n'est envoyé ici : l'achat (Purchase)
   n'est enregistré que par les applications TikTok et Meta,
   après un paiement réussi.
   ============================================= */

(function () {
  'use strict';

  var PROP_METHOD = 'Moyen de contact';
  var PROP_NUMBER = 'Numéro WhatsApp';
  var VALUE_WHATSAPP = 'WhatsApp';
  var VALUE_EMAIL = 'Email (adresse de la commande)';

  /* Longueur du numéro national (sans le 0 initial) pour les pays les plus fréquents */
  var NATIONAL_LENGTHS = {
    '33': [9], '32': [8, 9], '41': [9], '1': [10], '212': [9], '213': [9], '216': [8],
    '221': [9], '225': [10], '44': [10], '34': [9], '31': [9], '351': [9], '971': [9],
    '966': [9], '90': [10], '237': [9], '262': [9], '590': [9], '594': [9], '596': [9]
  };
  /* Pays où le 0 initial fait partie du numéro */
  var KEEP_LEADING_ZERO = { '39': true, '225': true };

  var PLACEHOLDERS = {
    '33': '6 12 34 56 78', '32': '470 12 34 56', '41': '78 123 45 67', '1': '514 555 0123',
    '212': '6 12 34 56 78', '213': '5 51 23 45 67', '216': '20 123 456', '221': '77 123 45 67'
  };

  var MESSAGES = {
    empty: 'Indiquez votre numéro WhatsApp, ou choisissez d\u2019être contacté par email.',
    needCode: 'Saisissez votre numéro avec son indicatif, par exemple +33 6 12 34 56 78.',
    invalid: 'Ce numéro ne semble pas valide. Vérifiez l\u2019indicatif du pays et le numéro saisi.',
    unavailable: 'Cette prestation ne peut pas être commandée pour le moment. Écrivez-nous sur WhatsApp, nous vous répondrons rapidement.',
    generic: 'Une erreur est survenue pendant la préparation de votre commande. Vérifiez votre connexion puis réessayez. Si le problème persiste, écrivez-nous sur WhatsApp.'
  };

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  }

  /* --- Requêtes panier (API Ajax Shopify) --- */
  function cartRequest(path, body) {
    var options = { method: body ? 'POST' : 'GET', headers: { 'Accept': 'application/json' }, credentials: 'same-origin' };
    if (body) {
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    var timeout = new Promise(function (resolve, reject) {
      setTimeout(function () { reject(new Error('timeout')); }, 15000);
    });
    return Promise.race([fetch(shopRoot() + path, options), timeout]).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok) {
          var error = new Error(data.description || data.message || ('HTTP ' + response.status));
          error.status = response.status;
          throw error;
        }
        return data;
      });
    });
  }

  /* Remplace la ou les lignes existantes du produit par une seule ligne (quantité 1) avec les coordonnées */
  function setOrderLine(variantId, properties) {
    return cartRequest('cart.js').then(function (cart) {
      var updates = {};
      var found = 0;
      (cart.items || []).forEach(function (item) {
        if (Number(item.variant_id) === variantId) {
          updates[item.key] = 0;
          found += 1;
        }
      });
      return found ? cartRequest('cart/update.js', { updates: updates }) : null;
    }).then(function () {
      return cartRequest('cart/add.js', { items: [{ id: variantId, quantity: 1, properties: properties }] });
    });
  }

  /* --- Vérification du format du numéro (ne confirme pas l'existence d'un compte WhatsApp) --- */
  function knownCodes(select) {
    var codes = [];
    Array.prototype.forEach.call(select.options, function (option) {
      var code = option.value.split(':')[1];
      if (code && codes.indexOf(code) === -1) codes.push(code);
    });
    return codes.sort(function (a, b) { return b.length - a.length; });
  }

  function normalizePhone(rawValue, countryValue, codes) {
    var raw = String(rawValue || '').trim();
    if (!raw) return { ok: false, reason: 'empty' };
    if (/[^\d\s().+\-\/]/.test(raw)) return { ok: false, reason: 'invalid' };

    var cleaned = raw.replace(/[\s().\-\/]/g, '');
    var code = null;
    var national;

    if (/^(\+|00)/.test(cleaned)) {
      var international = cleaned.replace(/^(\+|00)/, '');
      if (!/^\d+$/.test(international)) return { ok: false, reason: 'invalid' };
      for (var i = 0; i < codes.length; i++) {
        if (international.indexOf(codes[i]) === 0) { code = codes[i]; break; }
      }
      if (!code) {
        if (international.length < 8 || international.length > 15) return { ok: false, reason: 'invalid' };
        return { ok: true, e164: '+' + international };
      }
      national = international.slice(code.length);
    } else {
      code = (countryValue || '').split(':')[1] || null;
      if (!code) return { ok: false, reason: 'needCode' };
      if (!/^\d+$/.test(cleaned)) return { ok: false, reason: 'invalid' };
      national = cleaned;
    }

    if (!KEEP_LEADING_ZERO[code] && national.charAt(0) === '0') national = national.slice(1);

    var lengths = NATIONAL_LENGTHS[code];
    if (lengths) {
      /* Indicatif saisi sans « + » (ex. 33612345678 avec France sélectionnée) */
      if (lengths.indexOf(national.length) === -1 && national.indexOf(code) === 0 &&
          lengths.indexOf(national.length - code.length) !== -1) {
        national = national.slice(code.length);
      }
      if (lengths.indexOf(national.length) === -1) return { ok: false, reason: 'invalid' };
    } else if (national.length < 6 || (code + national).length > 15) {
      return { ok: false, reason: 'invalid' };
    }
    return { ok: true, e164: '+' + code + national };
  }

  /* --- Fenêtre de commande --- */
  function initOrderFlow() {
    var dialog = document.getElementById('order-dialog');
    if (!dialog) return; /* Sans fenêtre, les liens « Commander » mènent à la page produit */

    var form = dialog.querySelector('[data-order-form]');
    var submitBtn = dialog.querySelector('[data-order-submit]');
    var errorEl = dialog.querySelector('[data-order-error]');
    var phoneInput = dialog.querySelector('[data-order-phone]');
    var phoneWrap = dialog.querySelector('.order-phone');
    var phoneError = dialog.querySelector('[data-order-phone-error]');
    var countrySelect = dialog.querySelector('[data-order-country]');
    var panels = dialog.querySelectorAll('[data-order-panel]');
    var radios = dialog.querySelectorAll('input[name="order_contact_method"]');
    var closeButtons = dialog.querySelectorAll('[data-order-close]');
    var variantId = Number(dialog.getAttribute('data-variant-id'));
    var available = dialog.getAttribute('data-available') === 'true';
    var submitLabel = submitBtn.getAttribute('data-label') || submitBtn.textContent;
    var codes = knownCodes(countrySelect);
    var busy = false;
    var lastTrigger = null;
    var nativeModal = typeof dialog.showModal === 'function';

    function currentMethod() {
      var method = 'whatsapp';
      Array.prototype.forEach.call(radios, function (radio) { if (radio.checked) method = radio.value; });
      return method;
    }

    function setMethod(method) {
      Array.prototype.forEach.call(radios, function (radio) { radio.checked = radio.value === method; });
      syncPanels();
    }

    function clearPhoneError() {
      phoneError.hidden = true;
      phoneError.textContent = '';
      phoneInput.removeAttribute('aria-invalid');
      phoneWrap.classList.remove('is-invalid');
    }

    function setPhoneError(message) {
      phoneError.textContent = message;
      phoneError.hidden = false;
      phoneInput.setAttribute('aria-invalid', 'true');
      phoneWrap.classList.add('is-invalid');
    }

    function hideError() {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    function showError(message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function syncPanels() {
      var method = currentMethod();
      Array.prototype.forEach.call(panels, function (panel) {
        panel.hidden = panel.getAttribute('data-order-panel') !== method;
      });
      phoneInput.required = method === 'whatsapp';
      clearPhoneError();
      hideError();
    }

    function updatePlaceholder() {
      var code = countrySelect.value.split(':')[1];
      phoneInput.placeholder = code ? (PLACEHOLDERS[code] || 'Votre numéro') : '+44 7400 123456';
    }

    function setBusy(state) {
      busy = state;
      submitBtn.disabled = state || !available;
      submitBtn.setAttribute('aria-busy', state ? 'true' : 'false');
      submitBtn.textContent = state ? 'Préparation du paiement\u2026' : (available ? submitLabel : 'Actuellement indisponible');
      dialog.classList.toggle('is-busy', state);
    }

    function prefillFromCart() {
      cartRequest('cart.js').then(function (cart) {
        var line = (cart.items || []).filter(function (item) { return Number(item.variant_id) === variantId; })[0];
        if (!line || !line.properties) return;
        var method = line.properties[PROP_METHOD] || '';
        if (/^email/i.test(method)) {
          setMethod('email');
        } else if (line.properties[PROP_NUMBER] && !phoneInput.value) {
          phoneInput.value = line.properties[PROP_NUMBER];
          setMethod('whatsapp');
        }
      }).catch(function () { /* Pré-remplissage facultatif */ });
    }

    function openDialog(trigger) {
      if (busy) return;
      lastTrigger = trigger || null;
      hideError();
      clearPhoneError();
      if (nativeModal) {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
        dialog.classList.add('is-fallback');
      }
      document.documentElement.classList.add('order-dialog-open');
      prefillFromCart();
    }

    function afterClose() {
      document.documentElement.classList.remove('order-dialog-open');
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    }

    function closeDialog() {
      if (busy) return;
      if (nativeModal) {
        if (dialog.open) dialog.close();
      } else {
        dialog.removeAttribute('open');
        afterClose();
      }
    }

    dialog.addEventListener('close', afterClose);
    dialog.addEventListener('cancel', function (event) { if (busy) event.preventDefault(); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) closeDialog(); });
    Array.prototype.forEach.call(closeButtons, function (btn) { btn.addEventListener('click', closeDialog); });
    Array.prototype.forEach.call(radios, function (radio) { radio.addEventListener('change', syncPanels); });
    countrySelect.addEventListener('change', function () { updatePlaceholder(); clearPhoneError(); });
    phoneInput.addEventListener('input', clearPhoneError);

    /* Ouverture depuis tous les boutons « Commander » (carte tarif, page produit, panier) */
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-open-order]');
      if (!opener) return;
      event.preventDefault();
      openDialog(opener);
    });

    /* Page produit : le bouton « Commander ma LLC » ouvre la fenêtre
       (au lieu de l'ajout direct au panier géré par theme.js) */
    document.addEventListener('submit', function (event) {
      var productForm = event.target;
      if (!productForm || productForm === form || productForm.getAttribute('data-order-product') !== 'true') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      openDialog(productForm.querySelector('[type="submit"]'));
    }, true);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (busy || !available || !variantId) return;
      hideError();
      clearPhoneError();

      var properties;
      if (currentMethod() === 'whatsapp') {
        var result = normalizePhone(phoneInput.value, countrySelect.value, codes);
        if (!result.ok) {
          setPhoneError(MESSAGES[result.reason] || MESSAGES.invalid);
          phoneInput.focus();
          return;
        }
        properties = {};
        properties[PROP_METHOD] = VALUE_WHATSAPP;
        properties[PROP_NUMBER] = result.e164;
      } else {
        properties = {};
        properties[PROP_METHOD] = VALUE_EMAIL;
      }

      setBusy(true);
      setOrderLine(variantId, properties).then(function () {
        /* Le bouton reste désactivé jusqu'à l'ouverture du checkout (pas de double envoi) */
        window.location.href = shopRoot() + 'checkout';
      }).catch(function (error) {
        console.error('[Amanah] commande :', error);
        setBusy(false);
        showError(error && error.status === 422 ? MESSAGES.unavailable : MESSAGES.generic);
      });
    });

    /* Retour arrière depuis le checkout (cache navigateur) : réactiver le bouton */
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) setBusy(false);
    });

    window.AmanahOrder = { open: openDialog };
    updatePlaceholder();
    syncPanels();
    setBusy(false);
  }

  /* Exposé pour les tests de format */
  window.__amanahNormalizePhone = normalizePhone;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOrderFlow);
  } else {
    initOrderFlow();
  }
})();
